module.exports = __webpack_public_path__ + "assets/img/cb01.095c9274.png";